var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlockedRoadWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.25 19C3.25 19.4142 3.58578 19.75 4 19.75C4.41421 19.75 4.75 19.4142 4.75 19H3.25ZM19.25 19C19.25 19.4142 19.5858 19.75 20 19.75C20.4142 19.75 20.75 19.4142 20.75 19H19.25ZM5 5.75L19 5.75V4.25L5 4.25V5.75ZM19.25 6V11.5H20.75V6H19.25ZM19.25 11.5V19H20.75V11.5H19.25ZM3.25 6V11.5H4.75V6H3.25ZM3.25 11.5V19H4.75V11.5H3.25ZM20 10.75H4V12.25H20V10.75ZM7.32429 11.7528L9.65156 5.25282L8.23935 4.74718L5.91208 11.2472L7.32429 11.7528ZM11.397 11.7528L13.7243 5.25282L12.3121 4.74718L9.9848 11.2472L11.397 11.7528ZM15.4697 11.7528L17.797 5.25282L16.3848 4.74718L14.0575 11.2472L15.4697 11.7528ZM19 5.75C19.1381 5.75 19.25 5.86193 19.25 6H20.75C20.75 5.0335 19.9665 4.25 19 4.25V5.75ZM5 4.25C4.0335 4.25 3.25 5.0335 3.25 6H4.75C4.75 5.86193 4.86193 5.75 5 5.75V4.25Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockedRoadWhite);
export default __webpack_public_path__ + "static/media/blocked-road-white.f25b29010e1b1760a6cb0c13b220a7ae.svg";
export { ForwardRef as ReactComponent };